import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-menu',
  templateUrl: './setting-menu.component.html',
  styleUrls: ['./setting-menu.component.css']
})
export class SettingMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
